import { create } from "zustand";
import type { AlarmItem } from "../types";

interface EventState {
  items: AlarmItem[];
  pageNo: number;
  pageCount: number;
  total: number;
  selectedTaskId: string;
  loading: boolean;
  error: string | null;
  setItems: (items: AlarmItem[], pageCount: number, total: number) => void;
  addEvent: (item: AlarmItem) => void;
  setPageNo: (pageNo: number) => void;
  setSelectedTaskId: (taskId: string) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  reset: () => void;
}

const initialState: Omit<
  EventState,
  | "addEvent"
  | "setItems"
  | "setPageNo"
  | "setSelectedTaskId"
  | "setLoading"
  | "setError"
  | "reset"
> = {
  items: [],
  pageNo: 1,
  pageCount: 1,
  total: 0,
  selectedTaskId: "",
  loading: false,
  error: null,
};

export const useEventStore = create<EventState>((set) => ({
  ...initialState,
  addEvent: (newItem) =>
    set((state) => ({
      items: [newItem, ...state.items],
      total: state.total + 1,
    })),
  setItems: (items, pageCount, total) => set({ items, pageCount, total }),

  setPageNo: (pageNo) => set({ pageNo }),

  setSelectedTaskId: (taskId) =>
    set({
      selectedTaskId: taskId,
      items: [],
      pageNo: 1,
      pageCount: 1,
      total: 0,
      error: null,
    }),

  setLoading: (loading) => set({ loading }),

  setError: (error) => set({ error }),

  reset: () => set(initialState),
}));
